<app-loader></app-loader>

<router-outlet></router-outlet>

<!-- BUTTON TOP START -->
<button class="scroltop"><span class="fa fa-angle-up  relative" id="btn-vibrate"></span></button>

<!-- COOKIE CONSENT -->
<app-cookie-consent></app-cookie-consent>

<!-- GLOBAL SEARCH -->
<app-search-overlay></app-search-overlay>

<!-- GLOBAL TOASTS -->
<app-toast></app-toast>
